import { mapData } from "@/utilities/DataMapping";
import { PagePartComponent } from "../Enums";
import { IPagePartOptions } from "./IPagePartOptions";

export class ConfirmToContinueOptions implements IPagePartOptions {

    constructor(data?: IPagePartOptions) {
        if (data) this.update(data);
    }

    update(data: IPagePartOptions): ConfirmToContinueOptions {
        mapData(data, { root: () => this });
        return this;
    }

    get component(): PagePartComponent {
        return PagePartComponent.ConfirmToContinue;
    }
    set component(value: PagePartComponent) {
        if (value !== this.component) console.warn(`IPagePartOptions - trying to set component ${this.component} -> ${value}`)
    }

    // ADDING PROPERTIES - you also need to update the toJSON method!
    html: string = "";
    warningText: string = "Please confirm before continuing";
    isRedLineQuestion: boolean = false; // don't need this?

    // set in Briefing.vue to show 'error' message for missing answer
    shouldShowMissingMessage: boolean = false;

    // getter / setter properties are not serialised by JSON.stringify unless we do this:
    toJSON(): any {
        return {
            component: this.component,
            html: this.html,
            warningText: this.warningText,
            isRedLineQuestion: this.isRedLineQuestion
        };
    }

    static IsCorrect = (answer: string):boolean => answer === "Confirmed" || answer === "true" || answer === "True" || answer === "1";
}